import { render, staticRenderFns } from "./ExpiredWinning.vue?vue&type=template&id=6d9e4e3a&scoped=true&"
import script from "./ExpiredWinning.vue?vue&type=script&lang=js&"
export * from "./ExpiredWinning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e4e3a",
  null
  
)

export default component.exports